// Final settlement estimate (Phase 3b) — end-of-service gratuity + leave
// encashment. Read-only; self (employeeId omitted) or HR (per employee).
import { useState, useEffect } from 'react';
import { ShieldCheck } from 'lucide-react';
import { Card } from './ui';
import { AG } from './theme/tokens';
import { api } from './api';

export default function SettlementCard({ employeeId }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    (employeeId ? api.empSettlement(employeeId) : api.mySettlement()).then(setD).catch(() => setD(null));
  }, [employeeId]);

  if (!d) return null;
  const cur = d.currency || 'PKR';
  const money = (n) => `${cur} ${Number(n || 0).toLocaleString('en-IN')}`;

  const Row = ({ label, value, accent, strong, top }) => (
    <div className="flex items-center justify-between" style={{ fontSize: 14, padding: '9px 0', borderBottom: top ? 'none' : `1px solid ${AG.divider}`, borderTop: top ? `2px solid ${AG.n200}` : 'none', marginTop: top ? 4 : 0 }}>
      <span style={{ color: AG.n500 }}>{label}</span>
      <span style={{ color: accent ? AG.primary : AG.text, fontWeight: strong ? 700 : 500 }}>{value}</span>
    </div>
  );

  return (
    <Card style={{ padding: 20 }}>
      <div className="flex items-center gap-2" style={{ marginBottom: 6 }}>
        <ShieldCheck size={17} style={{ color: AG.primary }} />
        <h3 style={{ fontWeight: 600, color: AG.text }}>Final settlement (estimate)</h3>
      </div>
      <p style={{ fontSize: 12, color: AG.n500, marginBottom: 8 }}>
        Based on {d.years} {d.years === 1 ? 'year' : 'years'} of service{d.employee?.lastDay ? ` · last day ${d.employee.lastDay}` : ' · as of today'}.
      </p>
      <Row label={`Gratuity (${d.factor} mo/yr on ${money(d.monthlyWage)})`} value={money(d.gratuity)} />
      <Row label={`Leave encashment (${d.leaveDays} days)`} value={money(d.leaveEncashment)} />
      <Row label="Estimated total" value={money(d.total)} accent strong top />
    </Card>
  );
}
